import { SearchMapSize } from './'

export function getUpdatedMapSize(
  currentSize: SearchMapSize,
  size?: SearchMapSize,
): { size: SearchMapSize } | undefined {
  if (!!size && (currentSize.width !== size.width || currentSize.height !== size.height)) {
    return { size }
  }
}
